// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
// @ components
const { MortgageRequestAppraisalRequest } = require('components/mortgageRequest/mortgageRequestAppraisalRequest/mortgageRequestAppraisalRequest');

const MortageRequestAppraisalRequestView = props => {
    const { immGlobalPosition } = props;
    const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
    const mappingBreadcrumb = [
        {
            text: formatText('navbar-loans'),
            url: '/myprofile/loans-mortgages'
        },
        {
            text: formatText('mortgageRequestPresentation-title'),
            url: '/myprofile/mortgage/panel'
        },
        {
            text: formatText('mortgageRequestAppraisalRequest-title')
        }
    ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

    return (
        <div className="mortgage-request-appraisal-request-view">
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={getFinalTitle('mortgageRequestAppraisalRequest-title')}
                        />
                    </OKCover>
                </div>
            </div>
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        <div className="col-xs-12">
                            <MortgageRequestAppraisalRequest />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

MortageRequestAppraisalRequestView.propTypes = {
    immGlobalPosition: PropTypes.object.isRequired
}

module.exports = connect(
    state => ({
        immGlobalPosition: state.globalPosition,
    }), null
)(MortageRequestAppraisalRequestView);
